import { useQuery } from 'react-query';

import { CACHE_KEY_LIST_SETTINGS } from '@/modules/configuration/contants/settings';
import SettingsApiService from '@/modules/configuration/services/SettingsApiService';

export const useSettings = () => {
  const { isLoading, isError, error, data } = useQuery(CACHE_KEY_LIST_SETTINGS, async () => {
    const { data } = await SettingsApiService.search();
    return (data);
  }, { refetchOnWindowFocus: false });
  return { isLoading, isError, error, data };
};
